// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"0d7f217c","95":"1e605475","137":"8385ed17","155":"52b06149","211":"531685d8","225":"596dd587","344":"45df8718","654":"abbea589","691":"376eecad","715":"f8578e16","741":"cf323ce3","755":"427bf369","787":"284421de","869":"f698f1e3","920":"555b61c7"}[chunkId] + ".chunk.js";
};